import {
  required,
} from 'vuelidate/lib/validators';
import { EFieldNames } from '@shared/models/Enums/EFieldNames';

export interface ForgotPasswordModel {
  [EFieldNames.Email]: '';
}

export const forgotModel: ForgotPasswordModel = {
  [EFieldNames.Email]: '',
};

export const forgotFields = {
  [EFieldNames.Email]: {
    label: 'Email',
    icon: 'mdi-email-outline',
    errors: {
      required: 'Email is required',
    },
  },
};

export const forgotFieldsValidation = {
  [EFieldNames.Email]: {
    required,
  },
};
